<!--
Author: TangChen
Date: 2018-10-31
Desc: 风险评测组件，由index.js 配置引入
-->
<template>
    <div>
        <comp-title-dc back-url-name="risk">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager' }">账户管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/risk' }">风险测评</el-breadcrumb-item>
                <el-breadcrumb-item>风险测评试题</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <risk-ques :data="data" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import riskQues from "@/components/acctInfo/riskQuesDc.vue";
export default {
    name: "RiskTest",
    components: {
        riskQues
    },
    mixins: [mixin],
    props: {
        data: {
            type: Object,
            default: function () {
                return {
                    risk: true,
                    url: "risk"
                };
            }
        }
    },
    data() {
        return {};
    },
    methods: {}
};
</script>
<style lang="scss" scoped>

</style>
